import React, { useContext } from "react";
import { UserContext } from "../context/UserContext";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import Nav from "./Nav";
import Home from "../pages/Home";
import Games from "../pages/Games";
import About from "../pages/About";
import Login from "../pages/Login";
import Register from "../pages/Register";
import MovieDetail from "../pages/MovieDetail";
import GameDetail from "../pages/GameDetail";
import Account from "../pages/Account";
import MovieList from "../pages/MovieList";
import GameList from "../pages/GameList";
import MovieForm from "../pages/MovieForm";
import GameForm from "../pages/GameForm";

const Routes = () => {
  const PrivateRoute = (props) => {
    const { loginStatus } = useContext(UserContext);

    return loginStatus ? (
      <Route {...props} />
    ) : (
      <Redirect
        to={{
          pathname: "/login",
        }}
      />
    );
  };

  return (
    <Router>
      <Nav />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/games" component={Games} />
        <Route exact path="/about" component={About} />
        <Route exact path="/register" component={Register} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/movie/detail/:id" component={MovieDetail} />
        <Route exact path="/game/detail/:id" component={GameDetail} />

        <PrivateRoute path="/account" component={Account} />
        <PrivateRoute path="/movie/list/" component={MovieList} />
        <PrivateRoute path="/game/list/" component={GameList} />
        <PrivateRoute path="/movie/create" component={MovieForm} />
        <PrivateRoute path="/game/create" component={GameForm} />
        <PrivateRoute path="/movie/edit/:id" component={MovieForm} />
        <PrivateRoute path="/game/edit/:id" component={GameForm} />
      </Switch>
    </Router>
  );
};

export default Routes;
